import React, { useContext, useState, useEffect } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { CloseRounded } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';

const DeleteLocationModal = ({ modalDetails }) => {  

  console.log(modalDetails?.location);
  
  const data = modalDetails?.location;
  const companyID = data?.companyId;
  const locationID = data?.id;

  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);

  const [isDeleting, setIsDeleting] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  }
    
  const deleteLocation = async () => {
    console.log(companyID,locationID);

    
    
    try {
      setIsDeleting(true);
      const url = `${process.env.REACT_APP_API_URI}/v3/admin/company/${companyID}/location/${locationID}`;
      const response = await fetch(url, {
        method: 'DELETE', 
        headers: {
          Authorization: "Bearer " + authCtx.token,
        },
      });
  
      if (response.ok) {
        console.log('Location deleted successfully');
        setIsDeleting(false);
        modalCtx.setPageUpdate({ page: "CompaniesLocation", companyId: companyID, removedLocationId: locationID });        
        modalCtx.closeModal();
      } else {
        const errorData = await response.json();
        console.error('Error deleting location:', errorData);
      }
    } catch (error) {
      console.error('Network error:', error);
    } finally {
      setIsDeleting(false);
    }
  };
  

  return (
    <>
      <div className="modal-container">
        <div className='modal-header'>
          <h1>Delete Location</h1>
          {/* <CloseRounded className='close' onClick={() => closeHandle()} /> */}
        </div>
        <div className="modal-body">
          <span>Are you sure you want to delete this Location ?</span>
        </div>
        <div className="modal-footer">
          <Button className="cancel-btn" onClick={closeHandle} disabled={isDeleting}>CANCEL</Button>
          <Button onClick={() => deleteLocation()} disabled={isDeleting}>{isDeleting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} DELETE</Button>
        </div>
      </div>
    </>
  )
}

export default DeleteLocationModal;
